import en from './debtSaleStrings.en';

export default {
  en,
};
